/**
 * 充值签收弹窗 — 业务逻辑
 */

/** 弹窗展示类型 */
export const RECHARGE_CLAIM_TYPE = {
  RECHARGE: 'recharge', // 充值引导
  REDEEMED: 'redeemed', // 充值成功
}

/** 各类型 UI 文案配置（按 type 切换） */
export const RECHARGE_CLAIM_VIEW_CONFIG = {
  [RECHARGE_CLAIM_TYPE.RECHARGE]: {
    topLabel: 'Em Prêmios', // 顶部标语
    title: 'RECARREGUE E RECEBA', // 标题
    titleUppercase: true, // 标题是否大写
    descBefore: 'Você já acumulou ', // 描述前半段
    getDescAfter: (props) =>
      ` em prêmios! Deposite apenas R$ ${formatAmount(props.depositAmount)} para resgatar tudo.`, // 描述后半段
    primaryButton: 'DEPOSITAR E RESGATAR', // 主按钮文案
    secondaryButton: 'Deixar para depois', // 底部按钮文案
    primaryAction: 'deposit', // 主按钮行为：发起充值
  },
  [RECHARGE_CLAIM_TYPE.REDEEMED]: {
    topLabel: 'Resgatado',
    title: 'PRÊMIO RECEBIDO',
    titleUppercase: false,
    descBefore: 'Parabéns! Você resgatou todos os bônus de check-in diário no valor de ',
    getDescAfter: () =>
      '. O prêmio já foi creditado no seu saldo. Aproveite para jogar e ganhar agora!',
    primaryButton: 'JOGAR E GANHAR',
    secondaryButton: 'Agora não',
    primaryAction: 'goHome', // 主按钮行为：跳转游戏
  },
}

/** 格式化金额：28 -> "28,00" */
export const formatAmount = (value) => `${Number(value) || 0},00`

export function useRechargeClaim(props, emit) {
  /** 顶部栏背景图 */
  const topBarBgUrl = getImageUrlWithCDN_LOCAL('/home2/pop-up_top_bar_bg.png')
  /** 顶部笑脸装饰 */
  const smileyUrl = getImageUrlWithCDN_LOCAL('/home2/smiley_face_decoration.png')
  /** 气泡装饰 — 右侧 */
  const bubbleRightUrl = getImageUrlWithCDN_LOCAL('/home2/bubble_decorations_1.png')
  /** 气泡装饰 — 左下 */
  const bubbleLeftBottomUrl = getImageUrlWithCDN_LOCAL('/home2/bubble_decorations_2.png')
  /** 气泡装饰 — 左中 */
  const bubbleLeftMiddleUrl = getImageUrlWithCDN_LOCAL('/home2/bubble_decorations_3.png')

  /** 当前类型对应的展示数据 */
  const viewData = computed(() => {
    const config =
      RECHARGE_CLAIM_VIEW_CONFIG[props.type] ||
      RECHARGE_CLAIM_VIEW_CONFIG[RECHARGE_CLAIM_TYPE.RECHARGE]

    return {
      topLabel: config.topLabel, // 顶部标语
      title: config.title, // 标题
      titleUppercase: config.titleUppercase !== false, // 标题大写
      descBefore: config.descBefore, // 描述前段
      descHighlight: `R$ ${formatAmount(props.totalBonus)}`, // 高亮金额
      // 描述后段
      descAfter:
        typeof config.getDescAfter === 'function'
          ? config.getDescAfter(props)
          : config.descAfter || '',
      primaryButton: config.primaryButton, // 主按钮
      secondaryButton: config.secondaryButton, // 底部按钮
      primaryAction: config.primaryAction, // 主按钮行为
    }
  })

  /** 主按钮点击 */
  const handlePrimaryClick = () => {
    if (props.depositLoading) return

    if (viewData.value.primaryAction === 'deposit') {
      emit('deposit', { depositAmount: props.depositAmount })
      return
    }

    if (viewData.value.primaryAction === 'goHome') {
      emit('goHome')
    }
  }

  /** 底部按钮 — 关闭弹窗 */
  const handleLater = () => {
    if (props.depositLoading) return
    emit('close')
  }

  return {
    topBarBgUrl,
    smileyUrl,
    bubbleRightUrl,
    bubbleLeftBottomUrl,
    bubbleLeftMiddleUrl,
    viewData,
    handlePrimaryClick,
    handleLater,
  }
}
